import { useEffect } from 'react';

import { BannerPlacement, useAnimatedAppsBanner } from '@hook/useAnimatedAppsBanner';
import { AnimatedAppsPromotionBanner } from '@components/AnimatedAppsPromotionBanner';

export const CatalogAppsPromotionBanner = () => {
  const {
    placement,
    isCanShow,
    isVisible,
    handleShow,
    handleClose,
  } = useAnimatedAppsBanner(BannerPlacement.Category);

  useEffect(() => {
    if (isCanShow) {
      handleShow();
    }
  }, [isCanShow, handleShow]);

  return (
    <AnimatedAppsPromotionBanner
      placement={placement}
      isVisible={isVisible}
      onClose={handleClose}
    />
  );
};
